// Life Area glyphs, inline so they inherit the tile's white stroke.
// One per Life Area `icon` the backend sends (aris-core registry); shapes follow
// Figma node 9285:17268. An unknown icon renders the bulb.

const PATHS = {
  // Mind & Emotions: a head in profile with a calm wave inside.
  mind: (
    <>
      <path
        d="M9 20v-3.3A6.5 6.5 0 1118.4 10.5c0 1.1.5 2.1 1.3 2.9l-1.3 1.1V17a2 2 0 01-2 2H14.5v1"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 10.5c.9-1 1.8-1 2.7 0s1.8 1 2.7 0"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </>
  ),
  bulb: (
    <>
      <path
        d="M12 3a6 6 0 00-3.5 10.9V16h7v-2.1A6 6 0 0012 3z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M10 19h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </>
  ),
  heart: (
    <path
      d="M12 20s-7-4.3-7-9a4 4 0 017-2.6A4 4 0 0119 11c0 4.7-7 9-7 9z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  ),
  briefcase: (
    <>
      <rect
        x="3.5"
        y="7.5"
        width="17"
        height="12"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M9 7.5v-1A1.5 1.5 0 0110.5 5h3A1.5 1.5 0 0115 6.5v1"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    </>
  ),
  currency: (
    <>
      <path
        d="M12 4v16"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M15.5 8.2c0-1.5-1.6-2.4-3.5-2.4s-3.5.9-3.5 2.4S10 10.6 12 11s3.5 1.2 3.5 2.8-1.6 2.5-3.5 2.5-3.5-1-3.5-2.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </>
  ),
  pulse: (
    <path
      d="M3 12h3l2-4 3 8 3-6 2 2h5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  home: (
    <path
      d="M4 10.5L12 4l8 6.5V20H4v-9.5z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  ),
  fork: (
    <>
      <path
        d="M7 4l5 7 5-7"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 11v9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </>
  ),
  swap: (
    <>
      <path
        d="M4 9h14l-3-3M20 15H6l3 3"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  trend: (
    <>
      <path
        d="M4 17l5-5 3 3 7-7"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 8h4v4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  pray: (
    <path
      d="M12 3c-1 4-3 7-5 9l5 9 5-9c-2-2-4-5-5-9z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  ),
};

function LifeAreaIcon({ icon }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {PATHS[icon] || PATHS.bulb}
    </svg>
  );
}

export default LifeAreaIcon;
